import { defineStore } from 'pinia';
import { DialogPlugin } from 'tdesign-vue-next';

import axios from "axios";
import qs from 'qs';
import { Base64 } from 'js-base64'

import { useAppSettingStore } from '../index_SignIn';
import { store } from '../index_SignIn';

export const useChangePasswordStore = defineStore('changepassword', {
  state: () => ({
    username: '',
    password: '',
  }),
  getters: {

  },
  actions: {
    async changePassword(router: any, newPassword: string) {

      router.replace('/Result/info/修改密码/请稍候.../false');

      const appSettingStore = useAppSettingStore();

      const response = await axios.post('api/Authentication/ChangePassword', qs.stringify({
        'name': this.username,
        'password': this.password,
        'newPassword': newPassword
      })
      ).catch(function (error) {
        console.log(error);
      });

      var changePasswordResult = response.data;

      console.log(changePasswordResult);

      if (changePasswordResult === true) {
        // Modal.success({
        //     title: '密码修改成功',
        //     content: '请使用新密码登录。',
        //     okText: '返回登录',
        //     onOk: () => {
        //         emit('passwordChanged');
        //     },
        // });

        const confirmDia = DialogPlugin({
          header: '密码修改成功',
          body: '请使用新密码登录。',
          confirmBtn: '确定',
          cancelBtn: null,
          theme: 'success',
          onConfirm: ({ e }) => {
            confirmDia.hide();

            router.replace('/AccountPassword');
          },
        });
      }
      else {
        const confirmDia = DialogPlugin({
          header: '密码修改失败',
          body: '请新旧密码相同，请修改为不同。',
          confirmBtn: '确定',
          cancelBtn: null,
          theme: 'danger',
          onConfirm: ({ e }) => {
            confirmDia.hide();

            router.replace('/ChangePassword');
          },
        });
      }
    }
  }
});

export function getChangePasswordStore() {
  return useChangePasswordStore(store);
}
